import React from 'react';
import OtterIcon from './Icons/OtterIcon.jsx';
import ShootingStarIcon from './Icons/ShootingStarIcon.jsx';

const Title = () => {
	return (
		<div className={'dynamic-home-title'}>
			<OtterIcon/>
			<h1 className={'artz'}>Welcome back, Shmooperino! Enjoy your stay.</h1>
			<ShootingStarIcon/>
		</div>
	);
};

export default Title;
